import React from "react";

export default function PageHero({ title, sub, dark = false }) {
  return (
    <section className={`pt-[60px] ${dark ? "bg-brand-navy" : "bg-accent"}`}>
      <div className="max-w-3xl mx-auto px-6 py-16 text-center">
        <h1 className={`text-3xl sm:text-4xl lg:text-5xl font-extrabold leading-tight ${dark ? "text-white" : "text-brand-navy"}`}>
          {title}
        </h1>
        <p className={`mt-5 text-base sm:text-lg leading-relaxed ${dark ? "text-white/75" : "text-muted-foreground"}`}>
          {sub}
        </p>
      </div>
    </section>
  );
}